<template>
  <div class="main_box">
    <div class="body_title flex_layout_between">
      <h2>
        {{ $t('enum.notifications') }}
      </h2>
    </div>
    <div>
      <ul class="main_tabs" ref="messageList">
        <li @click="MsgTabs(6)" :class="MessageType==6?'on':''">{{ $t('enum.order') }}<span v-if="Counts.OrderCount>0">({{Counts.OrderCount}})</span></li>
        <!-- <li @click="MsgTabs(5)" :class="MessageType==5?'on':''">Bids<span v-if="Counts.AuctionCount>0">({{Counts.AuctionCount}})</span></li> -->
        <li @click="MsgTabs(2)" :class="MessageType==2?'on':''">{{ $t('enum.offer') }}<span v-if="Counts.ASKCount>0">({{Counts.ASKCount}})</span></li>
        <li @click="MsgTabs(7)" :class="MessageType==7?'on':''">{{ $t('enum.dispute') }}<span v-if="Counts.SRCount>0">({{Counts.SRCount}})</span></li>
        <li @click="MsgTabs(1)" :class="MessageType==1?'on':''">{{ $t('enum.fromCardHobby') }}<span v-if="Counts.SysCount>0">({{Counts.SysCount}})</span></li>
      </ul>
    </div>
    <table-messages :list="List" showType="messages" v-loading="loading" @getData="getData" />
    <list-pagination v-show="Count>0" ref="Pagination" :total="Count" @getData="getData" />
  </div>
</template>

<script>
import TableMessages from '@/components/tablemessages'
import ListPagination from '@/components/listpagination'
export default {
  name: '',
  components: { TableMessages, ListPagination },
  data() {
    return {
      loading: true, //page loading
      Counts: {},//各类目数
      List: [],//当前列表
      Count: 0,//当前总数
      MessageType: 6,//系统消息 = 1, 议价助手 = 2, 留言信息 = 3, 组队助手 = 4, 竞拍助手 = 5, 订单助手 = 6, 维权助手 = 7
      PageIndex: 1,
      PageSize: 60
    }
  },
  mounted() {
    var that = this;
    that.getData('', '', "NotificationCount");
    that.getData();
  },
  methods: {
    // 获取信息列表
    getData(PageIndex, PageSize, api = 'MyNotificationForWeb', params = "") {
      var that = this;
      var fun = "", method = "GET";
      that.loading = true;
      if (PageIndex && PageSize) { that.PageIndex = PageIndex; that.PageSize = PageSize; }
      switch (api) {
        case "NotificationCount": //获取消息未读数
          fun = function (res) {
            if (res.result) {
              that.Counts = res.data;
            }
          };
          break;
        case "MyNotificationForWeb": //消息二级列表_web专用
          params = `?MessageType=${that.MessageType}&pageIndex=${that.PageIndex}&pageSize=${that.PageSize}`;
          fun = function (res) {
            if (res.result) {
              that.List = res.data;
              that.Count = res.count;
            }
            that.loading = false;
          };
          break;
        default:
          break;
      }
      that.$get(api, params)
        .then((res) => {
          console.log("axios-res:", api, res);
          fun(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 切换消息二级列表
    MsgTabs(val) {
      let that = this;
      that.MessageType = val;
      that.getData("MyNotificationForWeb");
      that.$store.dispatch("scrollTop")
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/messages/index.vue